export default __webpack_public_path__ + "static/media/team-collaboration.db12568a.png";